import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation, ChangeDetectorRef, OnChanges, SimpleChanges } from '@angular/core';
import { ReceivedQuestion, Round } from '../../shared/model/poll.model';

@Component({
  selector: 'app-candidate-choices',
  templateUrl: './candidate-choices.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./candidate-choices.component.less', '../../shared/common.less'],
})

export class CandidatesChoicesComponent implements OnInit, OnChanges {
  @Input() isMobile: boolean;
  @Input() rounds: Array<Round>;
  @Input() electionSelected: number;
  @Input() listSelected: number;
  @Input() displayedCandidates: Array<ReceivedQuestion> = [];
  @Input() localAnswers: number[] = [];
  @Input() isVoteValid: boolean;
  @Input() isLoading: boolean = false;
  @Output() confirmSelectionEvent = new EventEmitter()
  @Output() setActiveListEvent = new EventEmitter<number>()
  @Output() setActiveCandidateEvent = new EventEmitter<number>()

  loading = false;

  constructor(private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.loading = this.isLoading;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.localAnswers != null) {
      this.localAnswers.forEach((answer, index) => {
        const checkbox = document.getElementById('checkbox-' + index) as HTMLInputElement;
        if (checkbox) {

          checkbox.checked = answer === 1;
        }
      });
    }
    this.cdr.detectChanges();
    // Ne réinitialiser loading que si isLoading passe à false (fin du traitement)
    if (changes['isLoading'] && !this.isLoading) {
      this.loading = false;
    }
  }

  selectionHandler(index: number) {
    this.setActiveCandidateEvent.emit(index);
  }

  locallyConfirmSelection() {
    this.loading = true;
    this.confirmSelectionEvent.emit();
  }

  setActiveList(event: number) {
    this.setActiveListEvent.emit(event);
  }
}
